import React from 'react';
import './careRecDescriptions';
export var CareRecDescription = function (props) {
    var careRecDescription = props.careRecDescription;
    return (React.createElement("div", { className: "mb-3 last:mb-0" },
        React.createElement("h3", { className: "mb-1 text-base font-bold leading-tight tracking-tight text-gray-700" }, careRecDescription.title),
        React.createElement("p", { className: "text-[15px] font-normal leading-tight text-gray-500" }, careRecDescription.description)));
};
export default CareRecDescription;
